import BasePolicy from './BasePolicy'
import $store from '@/store'

export default class ReportPolicy extends BasePolicy {

    beforeAll(verb, authorizable, onCustomer, __, company_id) {
        this.is_parent_company_selected = $store.getters['company/is_parent_company_selected']

        if (this.is_parent_company_selected && authorizable.hasRole('admin'))
            return true
    }

    create(authorizable) {
        return false
    }

    edit(authorizable, onCustomer) {
        return false
    }

    view(authorizable, onCustomer) {
        return false
    }

    list(authorizable, onCustomer) {
        return false
    }

    delete(authorizable, onCustomer) {
        return false
    }

}